import getMixins from './admin/mixins.js'
import getApiGenerator from './admin/api-generator'
import AdminRequisite from './admin/requisite'
import paramFilter from './admin/param-filter' // todo: deprecated

import isEmpty from './utils/isEmpty'
import match from './utils/match'
import typeOf from './utils/typeOf'
import getEnv from './utils/getEnv'
import parseQueryString from './utils/parseQueryString'
import dynamicallyLoadScript from './utils/dynamicallyLoadScript'
import getPropByPath from './utils/getPropByPath'
import EventBus from './utils/eventBus'
import validator, { highlightFormError } from './utils/validator'

import PullToRefresh from './components/PullToRefresh'
import OnefoldTable from './components/OnefoldTable'
import FormItemTip from './components/FormItemTip'
import CheckAllBox from './components/CheckAllBox'
import VideoPlayer from './components/VideoPlayer'
import AudioPlayer from './components/AudioPlayer'
import FormDialog from './components/FormDialog'
import Swal from './components/Swal'
import AuthButton from './components/AuthButton'
import Pagination from './components/Pagination'
import SmsButton from './components/SmsButton'
import AuthTree from './components/AuthTree'
import Selector from './components/Selector'
import SvgIcon from './components/SvgIcon'
import Tag from './components/Tag'
import QR from './components/QR'

const { succeed, warn, err, confirmation, notice } = Swal

export {
  //管理后台
  getMixins,
  getApiGenerator,
  highlightFormError,
  AdminRequisite,
  paramFilter, // todo: deprecated

  //消息提示
  Swal,
  Swal as SweetAlert, // todo: deprecated
  succeed,
  warn,
  err,
  confirmation,
  notice,

  //工具函数
  isEmpty,
  match,
  typeOf,
  EventBus,
  getEnv,
  parseQueryString,
  dynamicallyLoadScript,
  getPropByPath as deeplyAccessProp, //todo: deprecated
  getPropByPath,
  validator,
  validator as $validator, //todo: deprecated

  //趁手小型组件
  Pagination,
  Selector,
  AuthButton,
  SvgIcon,
  SmsButton,
  QR,
  Tag,
  CheckAllBox,
  OnefoldTable,
  VideoPlayer,
  AudioPlayer,
  FormDialog,
  AuthTree,
  PullToRefresh,
  FormItemTip
}
